import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Slide,
  Card,
  Grid,
  CardContent,
  DialogActions,
  Typography,
} from '@mui/material';
import CloudCircleIcon from '@mui/icons-material/CloudCircle';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const { de } = require('date-fns/locale');
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function DialogUpload(props) {
  const { open, data, handleClose, date, refresh, handleFileChange, handleUpload, files } = props;
  const [selectedItems, setSelectedItems] = useState([]);
  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={'md'}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Grid container direction="row">
          <Grid item xs={1} alignSelf={'center'}>
            <CloudCircleIcon fontSize="large" style={{ color: '#A9ACB4' }} />
          </Grid>
          <Grid xs item container direction={'row'}>
            <Grid item xs={12}>
              <Typography variant="subtittle2">{t('Uploadfiles.1')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography style={{ color: '#A9ACB4' }}>{t('Uploadfiles.2')}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ borderBottom: '3px solid #CBD0DC' }}></Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid
          textAlign={'center'}
          container
          direction={'row'}
          style={{ borderRadius: 5, border: '2px dotted #CBD0DC', padding: 20 }}
        >
          <Grid item xs={12}>
            <CloudDoneIcon />
          </Grid>
          <Grid item xs={12}>
            <Typography>{t('Uploadfiles.3')}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" style={{ color: '#A9ACB4' }}>
              {t('Uploadfiles.4')}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <div>
              <input type="file" accept="image/jpeg, image/png, application/pdf" multiple onChange={handleFileChange} />
            </div>
          </Grid>
        </Grid>
        <Grid container direction={'row'} style={{ marginTop: 20 }}>
          {/* {JSON.stringify(files)} */}
          {files.map((item) => (
            <Grid item xs={12}>
              <Card variant="outlined" style={{ marginBottom: 10, maxHeight: '100px', backgroundColor: '#EEF1F7' }}>
                <CardContent>
                  <Grid container direction={'row'} spacing={2}>
                    <Grid item style={{ alignSelf: 'center' }}>
                      <CloudCircleIcon fontSize="large" />
                    </Grid>
                    <Grid xs item container direction={'row'}>
                      <Grid item xs={12}>
                        <Typography variant="body1"> {item.name || item.nama_file}</Typography>
                      </Grid>
                      {/* <Grid item>
                        <Typography variant="caption">{(item.size / 1048576).toFixed(2)} MB</Typography>
                      </Grid> */}
                      <Grid item style={{ paddingLeft: 20 }}>
                        <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />
                      </Grid>
                      <Grid item>
                        <Typography variant="caption">{t('Uploadfiles.5')}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} style={{ color: 'red' }}>
          {t('Cancel.1')}
        </Button>
        <Button style={{ color: 'white', backgroundColor: '#1eb3d9' }} onClick={handleClose}>
          {t('Uploadfiles.6')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
